<action-box *ngIf="visible"
            class="graphics-detail detail-item {{extraStyles}}"
            iconLeft="graphics"
            [textLeft]="actionBoxTitle"
            [showHeader]="showHeader">
  <ng-container *ngIf="contentVisible" >
    <graphics-panel *ngFor="let graphics of graphicPanels"
                         [showInlineTitle]="showInlineTitle"
                         [isEditor]="false"
                         [configurationId]="configurationId"
                         [panel]="graphics"
                         class="{{''+graphics.longId}}"
                         [id]="graphics.longId"></graphics-panel>
  </ng-container>
  <div card-type="control" *ngIf="isPrintView">
    <print-checkbox (onValueChange)="onPrintValueChange($event)"></print-checkbox>
  </div>
</action-box>